import React from "react";
import { Input } from "../shared/Input";
import useLoginForm from "./useAuthForm/useLoginForm";

const Login = () => {
	const { register, onSubmit, errors } = useLoginForm();
	return (
		<div className="container mx-auto md:w-1/2  xl:w-1/3 px-2 py-5 shadow-xl bg-white mt-32 pt-1">
			<h1 className="text-2xl mb-6 text-center font-bold">Connexion</h1>
			<form onSubmit={onSubmit}>
				<Input
					label="Email"
					type="email"
					placeholder="mail@gmail.com"
					id="email"
					data-testid="email"
					{...register("email")}
					error={errors?.email}
				/>
				<Input
					label="Mot de passe"
					type="password"
					placeholder="**********"
					id="password"
					data-testid="password"
					{...register("password")}
					error={errors?.password}
				/>
				<div className="flex justify-end">
					<button type="submit" className="btn btn-primary p-2">
						Se connecter
					</button>
				</div>
			</form>
		</div>
	);
};

export default Login;
